import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { Event } from "./apiTypes";
import apiSlice from "./apiSlice";

export type EventReducerState = {
    selectedEvent: Event | null;
};

const initialState: EventReducerState = {
    selectedEvent: null,
};

const eventSlice = createSlice({
    name: "event",
    initialState,
    reducers: {
        selectEvent: (state, action: PayloadAction<Event>) => {
            state.selectedEvent = action.payload;
        },
        clearSelectedEvent: (state) => {
            state.selectedEvent = null;
        },
    },
    extraReducers: (builder) => {
        builder.addMatcher(apiSlice.endpoints.getEventById.matchFulfilled,
            (state, {payload}) => {
                state.selectedEvent = payload
            },
        )
    }
});

export const { selectEvent, clearSelectedEvent } = eventSlice.actions;
export default eventSlice.reducer;
